<template>
    <basic-map-popover
        class="store-map-popover"
        :title="name"
        :address="address"
    />
</template>

<script>
    import BasicMapPopover from '../BasicMapPopover/BasicMapPopover.vue';

    export default {
        name: 'store-map-popover',

        components: { BasicMapPopover },

        props: {
            name: {
                type: String,
                required: true,
            },

            address: {
                type: String,
                required: true,
            },
        },
    };
</script>
